import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import '../assets/css/app.css'
import axiosInstance from '../api/axiosInstance'
import session from "../utils/session";
import local from '../utils/local';
import { alert } from '../utils/comm';

export default function Login() {
  const navigate = useNavigate()

  const [id, setId] = useState('')
  const [password, setPassword] = useState('')

  const handleLogoClick = () => {
    navigate('/')
  }

  const handleLoginSubmit = async (e) => {
    e.preventDefault()

    // 유효성 검사
    if (!id.trim() || !password.trim()) {
      await alert('아이디와 비밀번호를 모두 입력해주세요.')
      return
    }

    try {
      const res = await axiosInstance.post('/account/login', {
        id: id,
        pswd: password,
      });


      // 로컬 스토리지에 저장
      local.setItem("SESSION_USER_ID", res.data.SESSION_USER_ID);
      local.setItem("SESSION_USER_NAME", res.data.SESSION_USER_NAME);

      // 세션 스토리지에 저장
      // session.setItem("SESSION_USER_ID", res.data.SESSION_USER_ID);
      // session.setItem("SESSION_USER_NAME", res.data.SESSION_USER_NAME);

      // const token = res.token
      // localStorage.setItem('accessToken', token)

      navigate('/docMng')
    } catch (err) {
      console.error('로그인 실패', err)

      if (err.response?.status === 401) {
        await alert({body : '로그인 정보가 일치하지 않습니다.'})
      } else {
        await alert({body : '로그인 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.'})
      }
    }
  }

  return (
    <form
      onSubmit={handleLoginSubmit}
      className="shuriken before:content-[''] before:z-[-1] before:w-screen before:bg-slate-50 before:top-0 before:h-screen before:fixed before:bg-texture-black before:bg-contain before:bg-fixed before:bg-[center_-20rem] before:bg-no-repeat flex items-center justify-center"
      style={{ height: '100vh', flexDirection: 'column', gap: '20px' }}
    >
      {/* 로고 및 타이틀 */}
      <div className="flex items-center px-3.5 py-2" style={{ maxWidth: '350px', width: '90%' }}>
        <div className="flex items-center cursor-pointer" onClick={handleLogoClick}>
          <div className="flex h-[34px] w-[34px] items-center justify-center rounded-lg bg-gradient-to-r from-theme-1 to-theme-2 transition-transform ease-in-out">
            <div className="relative h-[16px] w-[16px] -rotate-45 [&_div]:bg-white">
              <div className="absolute inset-y-0 left-0 my-auto h-[75%] w-[21%] rounded-full opacity-50"></div>
              <div className="absolute inset-0 m-auto h-[120%] w-[21%] rounded-full"></div>
              <div className="absolute inset-y-0 right-0 my-auto h-[75%] w-[21%] rounded-full opacity-50"></div>
            </div>
          </div>
          <div className="ml-3.5 font-medium">Document Login</div>
        </div>
      </div>

      {/* 아이디 입력 */}
      <div
        className="box flex items-center px-3.5 py-2"
        style={{ maxWidth: '350px', width: '90%' }}
      >
        <input
          className="ml-2.5 mr-auto"
          type="text"
          placeholder="ID"
          value={id}
          onChange={(e) => setId(e.target.value)}
          style={{ border: 'none', width: '100%' }}
        />
      </div>

      {/* 비밀번호 입력 */}
      <div
        className="box flex items-center px-3.5 py-2"
        style={{ maxWidth: '350px', width: '90%' }}
      >
        <input
          className="ml-2.5 mr-auto"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ border: 'none', width: '100%' }}
        />
      </div>

      {/* 로그인 버튼 */}
      <button
        type="submit"
        className="box flex cursor-pointer items-center justify-center px-3.5 py-2 hover:bg-slate-200/50"
        style={{
          maxWidth: '350px',
          width: '90%',
          textAlign: 'center',
          color: '#fff',
          background: 'rgb(11 69 109)',
          padding: '20px',
        }}
      >
        Member Login
      </button>
    </form>
  )
}
